<template>
    <div>
        <table class="custom-table responsive-table border-collapse">
            <thead class="font-normal">
                <tr class="shadow-table rounded-lg">
                    <th class="checkbox">
                        <base-checkbox />
                    </th>
                    <th v-for="header in filterEarnHeader" :key="header">{{ header.name || '' }}</th>
                    <th tabindex="-1">
                        <span @click="showFilterModal = true" class="cursor-pointer">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.7">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                                        fill="#383F51" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                                        fill="#383F51" />
                                </g>
                            </svg></span>
                    </th>
                </tr>
            </thead>
            <tbody v-if="!loading">
                <!-- <tr v-for="(trans, index) in transactions" :key="trans.id" class="shadow-table rounded-lg"> -->
                <tr v-for="(trans, index) in batchments" :key="trans.id" class="shadow-table rounded-lg">
                    <td>
                        <base-checkbox />
                    </td>
                    <td v-for="(header, index) in filterEarnHeader" :key="'path' + index" class="capitalize">
                        <!-- Special case for Category -->
                        <!-- <span v-if="header.name === 'Category'">{{ shippingType(trans) }}, {{ transactionType(trans) -->
                        <span v-if="header.name === 'Category'">{{ shippingType(trans) }}</span>
                        <span  v-else-if="header.name === 'Customer'">{{ trans.customer[0].firstname }} {{ trans.customer[0].lastname }}</span>
                        <span v-else-if="header.name === 'Batch ID'" class="block w-full ">
                             <span>
                                <!-- {{ trans.shipping.shippingReference }} -->
                                {{ trans.reference }}
                            </span>
                            <br>
                            <span class="opacity-50">
                                {{ createdAt(trans.createdAt) }}
                            </span>
                           
                        </span>


                        <span v-else> {{ getNestedValue(trans, header.path) }}</span>
                    </td>
                    <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
                        <span class="-full flex justify-center" @click="selectedRowId = index">
                            <vertical-ellipsis />
                        </span>

                        <div class="actions" v-if="selectedRowId == index">
                            <div @click="sendReciept(trans.id)" class="cursor-pointer hover:bg-gray-100">
                                <span class="icon"><img alt="" class="mr-1"
                                        src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                                <span>View Transaction</span>
                            </div>

                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- <EmptyContent v-if="!tableContent.length" /> -->
        <EarnFilterTable @resetEditHeader="resetEditHeader" :show-modal="showFilterModal"
            @close-modal="showFilterModal = false" />
        <CollectPayment :show-modal="collectPaymentModal" @close-modal="collectPaymentModal = false" />
    </div>
</template>

<script>
import EarnFilterTable from "../modals/EarningFilterTable.vue";
import CollectPayment from "../modals/CollectPayment.vue";
import moment from "moment";
//   import EmptyContent from "../svg/EmptyContent.vue";

export default {
    props: ["tableContent", 'transactions', 'batchments'],
    components: {
        EarnFilterTable,
        CollectPayment,
        //   EmptyContent,
    },
    data() {
        return {
            showFilterModal: false,
            collectPaymentModal: false,
            selectedRowId: -1,
            earnData: {},
            earnHeaders: [
                // { name: "Batch ID", active: true, path: 'shipping.shippingReference' },
                { name: "Batch ID", active: true, path: '' },
                { name: "Customer", active: true, path: '' },
                { name: "Category", active: true, path: '' },
                { name: "Revenue (NGN)", active: true, path: 'revenue' },
                { name: "Comm. Rate (%)", active: true, path: 'commissionRate' },
                { name: "Earning (NGN)", active: true, path: 'earning' },
                { name: "Payment Mode", active: true, path: 'payment_method' },
                { name: "Tips", active: false, path: 'tips' },
                { name: "Fleet Type", active: false, path: '' },
            ],
        };
    },
    computed: {
        filterEarnHeader() {
            return this.earnHeaders.filter((item) => item.active)
        }
    },
    methods: {
        resetEditHeader(val) {
            this.earnHeaders = this.earnHeaders.map((item, index) => {
                return { ...item, ...val[index] }
            })
        },
        getNestedValue(obj, path) {
            // Split the path into an array (e.g., 'customer.name' -> ['customer', 'name'])
            const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
            // Return 'N/A' if the value is missing (null, undefined, or empty string)
            return value === null || value === undefined || value === '' ? 'N/A' : value;
        },
        transactionType(trans) {
            let val = trans?.shipping?.shippingservice?.terminalType
            let type
            switch (val) {
                case 'terminal-to-door':
                    type = "T2D"
                    break;
                case 'terminal-to-terminal':
                    type = "T2T"
                    break;
                case 'door-to-door':
                    type = "D2D"
                    break;
                default:
                    type = ''
                    break;
            }

            return type
        },
        shippingType(val) {
            let value = val?.category?.terminalType
             if (value) {
                return value
            } 

            // let value = val?.shipping?.shippingservice?.isInternational
            // let valueuInterstate = val?.shipping?.shippingservice?.isInterstate
            // let valueuIntrastate = val?.shipping?.shippingservice?.isIntrastate

            // if (value) {
            //     return "International"
            // } else if (valueuInterstate) {
            //     return "Inter-State"
            // } else if (valueuIntrastate) {
            //     return "Intra-State"
            // } else {
            //     return ""
            // }

        },
        createdAt(val) {
            return moment(val).format('DD-MM-YYYY')
        },
        transactionRoute(val) {
            if (!val) return;
            localStorage.setItem("billing_reciept", "collection");
            this.$router.push({ name: "BCM_reciept", params: { id: val } });
        },
        sendReciept(val) {
            if (!val) return;
            this.$router.push({ name: "EARN_Billreciept", params: { id: val } });
        },
        statusBg(val) {
            let bg = "";
            switch (val) {
                case "pending":
                    bg = "text-red-500";
                    break;

                case "estimate":
                    bg = "text-primary-yellow";
                    break;

                default:
                    bg = "text-teal-500";
                    break;
            }
            return bg;
        },
    },
};
</script>

<style lang="scss" scoped>
.actions {
    @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
    min-width: 150px;
}

.actions div {
    @apply flex w-full py-2 px-2 items-center whitespace-nowrap;
}

.icon {
    width: 30px;
    padding-right: 5px;
}
</style>